import { render, staticRenderFns } from "./DonutChart24.vue?vue&type=template&id=1a2b982c&scoped=true"
import script from "./DonutChart24.vue?vue&type=script&lang=js"
export * from "./DonutChart24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b982c",
  null
  
)

export default component.exports